import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f1c8120c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=f1c8120c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c8120c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c8120c')) {
      api.createRecord('f1c8120c', component.options)
    } else {
      api.reload('f1c8120c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=f1c8120c&scoped=true&", function () {
      api.rerender('f1c8120c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0pnJQiuDB5k/JS/comp/Voucher.vue"
export default component.exports